@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';

:host {
  display: block;

  .templates {
    visibility: hidden;
  }

  // base control
  .jui-control {
    @include form-control-mixins.jui-control-base;
    row-gap: var(--jds-space-xxs);
    font-size: var(--jui-input-fs-sm);

    > * {
      flex: 1 100%;
    }

    &__label {
      @include form-control-mixins.form-control-label;

      &--disabled {
        @include form-control-mixins.form-label-disabled;
      }

      &--narrower {
        @include form-control-mixins.form-control-label-narrower;
      }
    }

    &__label-text {
      width: 100%;
    }

    &__error {
      @include form-control-mixins.form-control-error;
    }

    &__help {
      @include form-control-mixins.form-control-help--fieldset;
    }

    &__tooltip {
      @include form-control-mixins.form-control-tooltip;

      &--input-lg {
        @include form-control-mixins.form-control-tooltip;
      }
    }
    &__tooltip-text {
      @include form-control-mixins.form-control-tooltip-text;

      &--left {
        @include form-control-mixins.form-control-tooltip-text-left;
      }

      &--left-bottom {
        @include form-control-mixins.form-control-tooltip-text-left-bottom;
      }
    }

    &__tooltip-text::before {
      @include form-control-mixins.form-control-tooltip-text-before;
    }

    &__tooltip-text--left::before {
      @include form-control-mixins.form-control-tooltip-text-left-before;
    }

    &__tooltip-text--left-bottom::before {
      @include form-control-mixins.form-control-tooltip-text-left-bottom-before;
    }

    &__tooltip:hover .jui-control__tooltip-text {
      @include form-control-mixins.tooltip-hover;
    }

    &--lg {
      font-size: var(--jui-input-fs-lg);
      line-height: calc(var(--jui-input-fs-lg) * 1.5) !important;

      & .jui-control__error {
        font-size: var(--jui-input-fs-lg);
      }

    }

    &--sm {
      font-size: var(--jui-input-fs-sm);
      line-height: calc(var(--jui-input-fs-sm) * 1.5) !important;

      & .jui-control__input {
        font-size: var(--jui-input-fs-sm);
      }
    }

    &__btn {
      position: relative;
      max-width: max-content;
    }
  }

  .jui-file-input {

    &__action {
      margin: var(--jds-space-stack);
    }
    &__modal {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: var(--jui-file-modal-overlay-color-bg);
      z-index: 10000;

      &-close {
        position: absolute;
        top: var(--jds-space);
        right: var(--jds-space);
      }

      &-content {
        transform: translateY(-300%) scale(.2);
        animation: slideIn .3s ease-in-out forwards;
        position: fixed;
        display: flex;
        flex-direction: column;
        margin: auto;
        width: fit-content;
        height: fit-content;
        inset: 0;
        max-width: 660px;
        max-height: 100dvh;
        min-width: 660px;
        color:var(--jui-file-modal-color-contrast);
        background-color: var(--jui-file-modal-color-bg);
        padding: var(--jds-space-inset-lg);
        border-radius: var(--jui-border-radius);
        z-index: 10001;

        // mobile styles
        &--mobile {
          opacity: 0;
          min-width: clamp(280px, 87vw, 660px);
          max-width: unset;
          margin: auto auto var(--jds-space) auto;
          animation: slideUp 200ms ease-out forwards;

          & .jui-file-input__label {
            max-width: 190px;
          }

          & .jui-file-input__drop-text--sub {
            margin: var(--jds-space-stack-xs);
            font-size: var(--jui-file-input-fs);
          }

          & .jui-file-input__error {
            margin: var(--jds-space-stack-sm);
          }

          & .jui-file-input__files {
            height: unset;
            max-height: 250px;
          }

          & .jui-file-input__actions {
            display: flex;
            justify-content: space-between;
            gap: var(--jds-space);
          }

          & .jui-file-input__action {
            margin: var(--jds-space-stack-sm);
            flex-grow:1;
          }

          & .jui-file-input__upload-area {
            flex-direction: column;
          }
        }
      }
    }

    &__drop {
      min-width: 300px;
      height: 100%;
      border: 2px dashed var(--jui-drop-color-border);
      border-radius: var(--jui-border-radius);

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      background-color: var(--jui-drop-color-bg);
      color: var(--jui-drop-color-contrast);
      transition: background-color .4s ease, border-color .4s ease, color .4s ease;
      &:hover {
        transition: background-color .4s ease, border-color .4s ease, color .4s ease;
        background-color: var(--jui-drop-color-bg--hover);
        border-color: var(--jui-drop-color-border--hover);
        color: var(--jui-drop-color-contrast--hover);
      }

      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: var(--jds-space);
      }

      &-text {
        text-align: center;
        font-size: var(--jui-file-input-fs);
        font-weight: var(--jui-file-input-fw);
        margin: var(--jds-space-stack);
        &--lg {
          font-size: var(--jui-file-input-fs-lg);
        }
        &--sub {
          font-size: var(--jui-file-input-sm);
          color: var(--jui-drop-color-emphasis);
        }
      }
    }

    &__upload-area {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      gap: var(--jds-space);
    }

    &__upload {
      display: flex;
      flex-direction: column;
    }


    // uploaded
    &__uploaded {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
    &__header {
      margin: var(--jds-space-stack-xs);
      font-weight: var(--jui-file-input-fw-bold);
    }
    &__error {
      color: var(--jui-danger-color);
      font-size: var(--jui-file-input-fs-sm);
    }
    &__files {
      display: flex;
      flex-direction: column;
      margin: var(--jds-space-stack);
      height: 255px;
      overflow-y: auto;
    }
    &__file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: var(--jds-space-stack-xs);
      border: 1px solid var(--jui-input-color-border);
      border-radius: var(--jui-border-radius);
      padding: var(--jds-space-inset-xxs);
    }
    &__details {
      display: flex;
      margin: var(--jds-space-inline-sm);
      align-items: center;
      flex-grow: 1;
    }
    &__thumb {
      height: 40px;
      max-width: 40px;
      display: flex;
      justify-content: center;
      margin: var(--jds-space-inline-sm);
      flex-basis: 60px;

      &-img {
        border-radius: var(--jui-border-radius);
        max-height: 40px;
        max-width: 40px;

        &--invalid {
          border: 1px solid var(--jui-danger-color);
          border-radius: var(--jui-border-radius);
        }
      }
    }
    &__invalid {
      display: flex;
      flex-direction: column;
    }
    &__label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 255px;
      &--invalid {
        color: var(--jui-danger-color);


        &--sm {
          color: var(--jui-danger-color);
          font-size: var(--jds-theme-fs-xxs);
          font-style: italic;
        }
      }
    }
    &__file-actions {}
    &__uploaded-actions {
      display: flex;
      justify-content: space-between;
      align-self: flex-end;
    }
    &__uploaded-action {
      margin: var(--jds-space-inline-sm);
    }

  }
}

@keyframes slideIn {
 0% {
   transform: translateY(-300%) scale(.2);

 }
  100% {
    transform: translateY(0%) scale(1);
  }
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

